import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import b from 'b_';
import './ConsoleUL.css';

const block = b.lock('ConsoleUL');

export default function ConsoleUL({ children, className, listType, ...props }) {
    return <ul className={cn(block({ listType }), className)} {...props}> {children} </ul>;
}

ConsoleUL.propTypes = {
    listType: PropTypes.string,
};
